import RewardItemCard from "./RewardItemCard"
import RewardItemDetail from "./RewardItemDetail"
import {Card, Skeleton} from "antd"
import {useState} from "react"

const RewardCardSkeleton = () => (
  <Card className='reward-item-card mb-2' cover={<Skeleton.Image active />}>
    <Skeleton active paragraph={{rows: 3}} />
  </Card>
)


export function RewardItem(props) {
  const [isRewardDetailOpen, setIsRewardDetailOpen] = useState(false)

  const openRewardDetail = () => setIsRewardDetailOpen(true)
  const closeRewardDetail = () => setIsRewardDetailOpen(false)

  if (!props.reward)
    return (
      <>
        <RewardCardSkeleton/>
        <RewardCardSkeleton/>
        <RewardCardSkeleton/>
      </>
    )

  return (
    <>
      <RewardItemCard
        reward={props.reward}
        type={props.type}
        openRewardDetail={openRewardDetail}/>

      <RewardItemDetail
        reward={props.reward}
        type={props.type}
        active={isRewardDetailOpen}
        close={closeRewardDetail}/>
    </>
  )

}